import type { DocumentsLinkData } from './useDocumentsLinkData.types';
import type { DocumentsLinkHandlers } from './useDocumentsLinkHandlers.types';

import { copyTextToClipboard } from 'utils/dom';

import { useCallback } from 'react';

export const useDocumentsLinkHandlers = ({
  localState,
  localActions
}: {
  localState: DocumentsLinkData['localState'];
  localActions: DocumentsLinkData['localActions'];
}): DocumentsLinkHandlers => {
  const handleUrlCopy = useCallback(() => {
    if (localState.url) {
      copyTextToClipboard(localState.url);
      localActions.setUrl(null);
      localActions.setIsModalOpen(false);
    }
  }, [localActions, localState.url]);

  const handleModalClose = () => {
    localActions.setUrl(null);
    localActions.setIsModalOpen(false);
  };

  return { handleUrlCopy, handleModalClose };
};
